import React from "react";
import Breadcrumb from "../breadcrumb";
import { History } from "../history";
import { cn } from "../../../utils/cn";

export function Chat({ children, className, ...props }) {
    return (
      <div
        {...props}
        className={cn(
          'flex-1 w-full overflow-auto flex flex-col-reverse gap-4 p-4',
          className
        )}
      >
        {children}
      </div>
    );
  }

export const ChatScreen = ({ children, pageLabel, slug, route }) => {
    return (
      <>
        <div className='flex gap-8 h-full w-full overflow-hidden'>
          <div className='flex flex-col hidden lg:block'>
            <div className='mb-4'>
              <Breadcrumb pageLabel={pageLabel} />
            </div>
            <History key="history" slug={slug} route={route} />
          </div>
          <div className='flex flex-col h-full flex-1 w-full'>
            <div className='flex-1 overflow-hidden flex flex-col'>
              {children}
            </div>
          </div>
        </div>
        {/* <NavBarMobileHistory /> */}
      </>
    );
  }